import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import Link from '../../components/buttons/Link';
import BlueButton from '../../components/buttons/BlueButton';
import LabelError from '../../components/labels/LabelError';

import passwordIcon from '../../images/password_blue.svg';
import logo from '../../images/visualmanagement.png';

import { bindActionCreators } from 'redux';
import * as actionsSession from '../../actions/session.actions';

// eslint-disable-next-line
import style from './_style.css';

function validatePassword(password) {
    var re = /^[a-zA-Z\-0-9]*$/;
    return re.test(password) && password.length > 0;
}

class Login extends React.Component {
    state = {
        error: undefined,
        password: '',
    };

    constructor(props) {
        super(props);
        this.enterFunction = this.enterFunction().bind(this);
    }

    UNSAFE_componentWillMount() {
        window.addEventListener('keydown', this.enterFunction);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.enterFunction);
    }

    enterFunction = () => (event) => {
        if (event.keyCode === 13) {
            this.handleClick();
        }
    };

    handleClick = (event) => {
        const { password } = this.state;
        if (this.isCorrect(password)) {
            this.props
                .recoveryPassword(password, this.props.match.params.token)
                .then((response) => this.props.history.push('/user/login'))
                .catch((error) => this.setState({ error: error.message }));
        }
    };

    isCorrect = (password) => {
        return validatePassword(password);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleReset = (event) => {
        this.props.history.push('/user/login');
    };

    render() {
        const { password } = this.state;
        const { intl } = this.props;
        const divStyle = { backgroundImage: 'url(' + logo + ')' };
        const divStylePassword = { backgroundImage: 'url(' + passwordIcon + ')' };
        return (
            <form>
                <div className={'fullscreen flex_full_column'}>
                    <div className={'logo margin_bottom_24'} style={divStyle} />
                    <div
                        className={
                            'align_center display_flex flex_direction_column margin_bottom_24'
                        }
                    >
                        <Grid container justify="center">
                            <Grid item xs={10} sm={6} className={'text_align_center'}>
                                <span
                                    className={
                                        'barlowsemicondensed_bold flex_full text_align_center c_dark_grey_blue '
                                    }
                                >
                                    <FormattedMessage id="recovery_password_title" />
                                </span>
                            </Grid>
                        </Grid>
                        <Grid container justify="center">
                            <Grid item xs={10} sm={6} className={'text_align_center'}>
                                <span
                                    className={
                                        'barlow_medium_tree_local margin_top_18  text_align_center flex_full c_dark_grey_blue '
                                    }
                                >
                                    <FormattedMessage id="recovery_password_text" />
                                </span>
                            </Grid>
                        </Grid>
                        <div className={'flex_full_row width100 margin_top_9'}>
                            <Grid container justify="center" alignItems="center">
                                <Grid item xs={10} sm={6}>
                                    <div
                                        style={divStylePassword}
                                        className={
                                            'padding_left_36 text_field_icon  margin_top_9 margin_bottom_24'
                                        }
                                    >
                                        <TextField
                                            fullWidth
                                            id="password"
                                            name="password"
                                            required
                                            helperText={
                                                !password
                                                    ? intl.formatMessage({ id: 'required' })
                                                    : ''
                                            }
                                            label={intl.formatMessage({ id: 'password' })}
                                            className={'padding_bottom_24 margin_top_9'}
                                            type="password"
                                            margin="normal"
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <div className={'flex_full_row width100 margin_top_9'}>
                            <Grid container justify="center" alignItems="center">
                                <Grid item xs={10} sm={6}>
                                    <Link id="login_back" onClick={this.handleReset} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <div className={'align_botton display_flex'}>
                        <Grid container justify="center" className={'flex_grow_1 align_center'}>
                            <Grid item xs={10} sm={6} className="padding_bottom_48">
                                <BlueButton id="next" onClick={this.handleClick} />
                            </Grid>
                        </Grid>
                    </div>
                    <div className={'fixed_footer'}>
                        {this.state.error !== undefined ? (
                            <LabelError message={this.state.error} />
                        ) : (
                            <div />
                        )}
                    </div>
                </div>
            </form>
        );
    }
}

Login.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        form: state.form,
        session: state.session,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsSession), dispatch);
};

Login = injectIntl(Login);
Login = withRouter(Login);

Login = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Login);

export default Login;



// WEBPACK FOOTER //
// ./src/pages/knowhow/RecoveryPassword.js